import React from 'react';

const Colophon = () => {
    return (
        <footer className="colophon">
            Andrew Lanpouthakoun, {new Date().getFullYear()}
        </footer>
    );
};

export default Colophon;
